import { render, staticRenderFns } from "./indexEmbarazosAnteriores.vue?vue&type=template&id=344d5e39&"
import script from "./indexEmbarazosAnteriores.vue?vue&type=script&lang=js&"
export * from "./indexEmbarazosAnteriores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports